import ViewCad from "../../../config/view";
import { PacienteViewProps } from "../paciente.controller";
import { Paciente } from "../paciente.model";

interface PacienteCadastroProps extends PacienteViewProps {
    handleCloseView: () => any
}

export function PacienteCadastro(props: PacienteCadastroProps) {
    const { pacienteActions,pacienteState, handleCloseView } = props
    const { error, loading, msg, row, showAlert, showDialogExluir, status,rows } = pacienteState
    const { create, read, update, deletar, set, get, setShowAlert, setShowDialogExluir, setClearValue,setShowMsg } = pacienteActions

    const handleNovo = () => {
        setClearValue();
    }

    const handleExcluir = (row: Paciente) => {
        deletar(row);
        setShowDialogExluir(false);
        handleCloseView();
    }

    const formValidate = (values: Paciente) => {
        const errors: any = {}
        if (!values.nome)
            errors.nome = "Informe o nome do paciente"
        return errors
    }

    const handleUpdate = (value: Paciente) => {
        console.log("chamou handleUpdate em paciente",value);
        if (!value._rev) {
            if(verificarMesmoNome(value.nome)){
                setShowMsg("Já existe um paciente com esse nome!","error");
            } else {
                create(value);
            }
        } else {
            update(value);
        }
    }

    const verificarMesmoNome = (nome:string) => {
        let find = rows.find(row=>row.nome.toLowerCase() === nome.toLowerCase())
        if(find)
            return true
        return false
    }

    var viewCad = new ViewCad({
        formTitle: "Cadastro do paciente",
        formFieldDescription: "nome",
        loading: loading,
        msg: msg,
        row: row,
        status: status,
        showAlert: showAlert,
        showDialogExluir: showDialogExluir,
        buttonNovo: {
            show: true,
            title: "Adicionar novo paciente",
            onClick: () => handleNovo(),
        },
        handleExcluir: handleExcluir,
        formValidate: formValidate,
        handleUpdate: handleUpdate,
        handleCloseAlert: () => setShowAlert(false),
        setShowDialogExluir: setShowDialogExluir,
        handleCloseView: () => handleCloseView(),
        contentForm: [
            { fieldName: "nome", label: "Nome", type: "text", key: "nome", colunsXS: 12, colunsSM: 6, colunsMD: 8, require: true },
            { fieldName: "whatsapp", label: "Whatsapp", type: "text-mask",maskInputText:"(__)_ ____-____", key: "whatsapp", colunsXS: 12, colunsSM: 6, colunsMD: 4, require: true, },
        ],
    })

    return viewCad
}



